import { PropsWithChildren } from "react";

function StickyHeader({ children }: PropsWithChildren<unknown>) {
	return (
		<div className="sticky-header" data-qa="sticky-header">
			<div className="sticky-header-placeholder"></div>
			<div className="sticky-header-el">{children}</div>
		</div>
	);
}

export default StickyHeader;
